import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AppButtonComponent } from '../../layout/components/button/button.component';
import { ConsentService } from '../../core/services/consent.service';

/**
 * Aviso de transparência sobre o uso de analytics (base legal: legítimo interesse).
 * Não bloqueia o uso do app — oferece opt-out imediato ("Recusar") e é dispensável
 * ("Ok, entendi"). Exibido uma vez por dispositivo, enquanto não houver decisão
 * registrada no {@link ConsentService}.
 */
@Component({
  selector: 'app-consent-banner',
  standalone: true,
  imports: [CommonModule, RouterModule, AppButtonComponent],
  template: `
    @if (!(consent.noticeDismissed$ | async)) {
      <div
        class="fixed bottom-0 inset-x-0 z-[10000] p-3 md:p-4 flex justify-center pointer-events-none"
        role="region"
        aria-label="Aviso de privacidade"
      >
        <div
          class="pointer-events-auto w-full max-w-3xl bg-white dark:bg-[#27272A] border border-[#EADFD3] dark:border-white/10 rounded-xl shadow-lg p-4 flex flex-col md:flex-row md:items-center gap-3"
        >
          <div class="flex-1 text-sm text-[#52525B] dark:text-white/80 leading-5">
            <span class="block font-semibold text-[#27272A] dark:text-white mb-0.5">
              Uso de dados para melhorar o app
            </span>
            Coletamos dados de uso (analytics) para aprimorar o Smart App, com base no
            nosso legítimo interesse. Você pode recusar a qualquer momento.
            <a routerLink="/public/politica-de-privacidade" class="text-[#F4511E] underline whitespace-nowrap">
              Saiba mais
            </a>.
          </div>
          <div class="flex gap-2 shrink-0">
            <app-button
              (onClick)="consent.denyAnalytics()"
              [props]="{ label: 'Recusar', severity: 'secondary', variant: 'outlined', style: { height: '40px' } }"
            ></app-button>
            <app-button
              (onClick)="consent.dismissNotice()"
              [props]="{ label: 'Ok, entendi', severity: 'primary', style: { height: '40px' } }"
            ></app-button>
          </div>
        </div>
      </div>
    }
  `,
})
export class ConsentBannerComponent {
  constructor(public readonly consent: ConsentService) {}
}
